import React from "react";
import Overview from ".";
import { SplitContent } from "../../EditingRouter/components/SplitContent";
import { SubToPages_pages } from "../../../api/SubToPages";

export const PaginatedOverview = ({ projectId, allPages }: {
  projectId: string;
  allPages: SubToPages_pages[];
}) => {
  const pageProps = { projectId, allPages };
  return <SplitContent component={Overview} props={pageProps}>{allPages}</SplitContent>;
};
